import type { ReactNode, CSSProperties } from "react";

type Props = {
  children: ReactNode;
  ember?: boolean;
  onClick?: () => void;
  id?: string;
  testId?: string;
  className?: string;
  disabled?: boolean;
  style?: CSSProperties;
  type?: "button" | "submit" | "reset";
};

/**
 * PrimaryAction — bordered CTA button.
 * Uses .rc-action from monastery.css.
 */
export function PrimaryAction({
  children,
  ember = false,
  onClick,
  id,
  testId,
  className = "",
  disabled = false,
  style,
  type = "button",
}: Props) {
  const classes = ["rc-action", ember && "rc-action--ember", className]
    .filter(Boolean)
    .join(" ");

  const handleClick = () => {
    if (disabled) return;
    navigator.vibrate?.(10);
    onClick?.();
  };

  return (
    <button
      id={id}
      data-testid={testId}
      className={classes}
      onClick={handleClick}
      type={type}
      disabled={disabled}
      style={style}
      aria-label={typeof children === "string" ? children : undefined}
    >
      {children}
    </button>
  );
}
